<ng-container [ngTemplateOutlet]="templateTitle || templateDefaultTitle">
</ng-container>
<ng-template #templateDefaultTitle>
  <h1 mat-dialog-title *ngIf="data.OnlyAssembly">
    {{ data.searching }}
  </h1>
  <h1 mat-dialog-title *ngIf="!data.OnlyAssembly">
    {{ data.title || workOrderData?.itemName }}
  </h1>

  <mat-list
    *ngIf="data.includeInspectionSheet"
    class="tw-flex tw-justify-center tw-mb-4"
  >
    <a
      [disabled]="!measurementData?.urlDrive"
      [href]="measurementData?.urlDrive"
      class="inspection-sheet"
      mat-icon-button
      target="_blank"
    >
      <mat-icon>description</mat-icon>
    </a>
  </mat-list>
</ng-template>
<mat-dialog-content class="dialog-content">
  <div class="additional-data">
    <div *ngIf="workOrderData?.description">
      <h3>Descripcion:</h3>
      <p>{{ workOrderData?.description }}</p>
    </div>
    <div *ngIf="workOrderData?.specialInstructions">
      <h3>IE Work order:</h3>
      <p>{{ workOrderData.specialInstructions }}</p>
    </div>
    <div *ngIf="workOrderData?.itemSpecialInstructions">
      <h3>IE numero de parte:</h3>
      <p>{{ workOrderData.itemSpecialInstructions }}</p>
    </div>
    <div *ngIf="workOrderData?.destination">
      <h3>Destino:</h3>
      <p>{{ workOrderData.destination }}</p>
    </div>
    <ng-container [ngTemplateOutlet]="templateExtraData"></ng-container>
  </div>
  <mat-progress-bar [hidden]="!loading" mode="indeterminate"></mat-progress-bar>
  <mat-tab-group [hidden]="loading" mat-stretch-tabs mat-align-tabs="center">
    <mat-tab *ngIf="bom.length > 0" label="Numero de parte">
      <div class="table-wrapper">
        <app-bom-details-table
          (emitterChange)="validateBomLot($event)"
          [columns]="displayedColumns"
          [list]="bom"
        ></app-bom-details-table>
      </div>
    </mat-tab>
    <mat-tab *ngIf="showLineBom && lineBom.length > 0" label="Work Order">
      <div class="table-wrapper">
        <app-bom-details-table
          (emitterChange)="validateBomLot($event)"
          [columns]="displayedColumns"
          [list]="lineBom"
        ></app-bom-details-table>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="tw-bg-gray-300 hover:tw-bg-gray-100"
    mat-dialog-close
    mat-raised-button
  >
    Close
  </button>
</mat-dialog-actions>
